module.exports = __webpack_public_path__ + "img/status-wallet.72cc8669.png";